import { render } from "./PanelProductDetails.vue?vue&type=template&id=4ad39e0a"
import script from "./PanelProductDetails.vue?vue&type=script&lang=js"
export * from "./PanelProductDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__